import html2pdf from "html2pdf.js";

/**
 * Generic utility to generate and download PDF from any DOM node.
 * @param elementRef - React ref to the element to convert
 * @param fileName - Optional file name (default: 'document.pdf')
 */
export const generatePDF = async (
  elementRef: React.RefObject<HTMLElement | null>,
  fileName: string = "document.pdf"
): Promise<void> => {
  if (!elementRef?.current) {
    console.error("❌ PDF Generator: elementRef is empty");
    return;
  }

  try {
    const element = elementRef.current as HTMLElement;

    const options = {
      margin: [10, 10, 10, 10],
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    await html2pdf()
      .set(options as any)
      .from(element)
      .save();
  } catch (err) {
    console.error("❌ PDF generation failed:", err);
    throw err;
  }
};
